import axios from 'axios'
import {ClaimFile, SupersedingCycle, UploadSupersedingFilesParams} from '../types/superseding'

const API_BASE_URL = process.env.REACT_APP_API_CLAIM_URL

export const fetchSupersedingCycles = async (claimNumber: string): Promise<SupersedingCycle[]> => {
  const response = await axios.get(`${API_BASE_URL}/api/Claims/${claimNumber}/Superseding`)
  return response.data?.data || response.data || []
}

// Returns a flat list of every uploaded file for the claim (across all labels).
// Superseding documents are matched to a cycle by their glNumber appearing in the file name.
export const fetchClaimFiles = async (claimNumber: string): Promise<ClaimFile[]> => {
  const response = await axios.get(`${API_BASE_URL}/api/Claims/ListFiles/${claimNumber}`)
  if (!response.data?.isSuccess) return []
  const groups = response.data.data || []
  return groups.flatMap((group: any) =>
    (group.document || []).map((file: any) => ({
      ...file,
      label: group.label,
    }))
  )
}

// Resolves a signed URL for a stored file so it can be downloaded/previewed.
export const getClaimFileUrl = async (
  claimNumber: string,
  fileName: string
): Promise<string | null> => {
  const response = await axios.get(
    `${API_BASE_URL}/api/Claims/GetFile?claimNumber=${claimNumber}&fileName=${encodeURIComponent(
      fileName
    )}`
  )
  return response.data?.isSuccess ? response.data?.data?.url || null : null
}

export const uploadSupersedingDocuments = async (
  params: UploadSupersedingFilesParams
): Promise<any> => {
  const {claimNumber, username, files} = params

  const formData = new FormData()
  files.forEach((file) => {
    formData.append('files', file)
  })
  const response = await axios.post(
    `${API_BASE_URL}/api/Claims/Superseding/${claimNumber}/Documents?username=${encodeURIComponent(
      username
    )}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return response.data
}
